<!--
 * @Description: 基础弹层组件
 * @Date: 2019-08-16 11:23:03
 -->
<template>
  <el-dialog
    v-bind="attrs"
    v-on="$listeners"
    :class="{ 'new-ui': attrs.isNewUI }"
  >
    <template slot="title">
      <slot name="title"></slot>
    </template>

    <div class="xrk-dialog-scroll">
      <slot></slot>
    </div>
    <template slot="footer">
      <slot name="footer">
        <div
          class="xrk-dialog-footer"
          v-if="attrs.showCancel || attrs.showConfirm"
        >
          <el-button
            v-if="attrs.showCancel"
            :type="attrs.cancelType"
            @click="footerHandle('cannel')"
          >
            {{ attrs.cancelText }}
          </el-button>
          <el-button
            v-if="attrs.showConfirm"
            :type="attrs.confirmType"
            @click="footerHandle('confirm')"
          >
            {{ attrs.confirmText }}
          </el-button>
        </div>
      </slot>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'xrkDialog',
  data() {
    return {
      background: '#fff',
      visible: true,
      width: 'auto',
      title: '提示',
      top: '',
      center: true,
      'close-on-click-modal': false,
      'close-on-press-escape': false,
      'show-close': true,
      'custom-class': 'xrk-dialog',
      'before-close': this.beforeClose,
      'destroy-on-close': false,
      'modal-append-to-body': false,
      // 额外参数
      showDefaultFooter: false, // 是否使用默认footer
      showConfirm: true,
      confirmType: 'primary',
      confirmText: '确定',
      showCancel: true,
      cancelType: 'default',
      cancelText: '取消',
      isNewUI: false
    };
  },
  components: {},
  watch: {},
  computed: {
    attrs() {
      // return Object.assign(this.$data, this.$attrs);
      return {
        ...this.$data,
        ...this.$attrs
      };
    }
  },
  methods: {
    beforeClose(done) {
      this.$xrkDialog.remove();
    },
    footerHandle(event) {
      if (event === 'cannel') {
        this.beforeClose();
      }
      this.$emit('defaultBtEmit', event);
      if (
        this.success &&
        Object.prototype.toString.call(this.success) == '[object Function]'
      ) {
        this.success({
          confirm: event == 'confirm',
          content: this.$slots.default.componentInstance,
          dialog: this
        });
      }
    }
  },
  created() {},
  mounted() {},
  beforeDestroy() {}
};
</script>

<style lang="scss">
@import '~@/styles/mixin.scss';
@import '~@/styles/theme.scss';
>>> .default-footer {
  display: flex;
  justify-content: flex-end;
}
.el-dialog__wrapper {
  // line-height: 1;
  .xrk-dialog {
    @include absolute_mid();
    width: auto;
    margin: 0;
    background-color: #fff;
    border-radius: $--radius-main * 1.5;
    .el-dialog__header {
      padding: 15px 0 15px;
      position: relative;
      z-index: 999;
      .el-dialog__title {
        font-size: 24px;
      }
      .el-dialog__headerbtn {
        top: 10px;
      }
    }
    .el-dialog__body {
      // padding: 32px 24px;
      // padding-top: 40px;
      padding-bottom: 0;
      transform: translateX(-1px) translateY(-10px);
      overflow-y: auto;
      max-height: 80vh;
    }
    &-scroll {
      // overflow-y: auto;
      // max-width: 90vw;
      // max-height: 70vh;
    }
    &-footer {
      width: 100%;
      margin-top: 20px;
      text-align: center;
      margin-bottom: 20px;
      .el-button + .el-button {
        margin-left: 110px;
      }
    }
  }
}

// .custom-dialog {
//   width: auto;
//   min-width: 600px;
//   max-width: 80%;
// }
// @import '@/styles/mixin.scss';
// .dialog {
//   .el-dialog {
//     width: 90vw;
//     /*标题样式*/
//     .el-dialog__header {
//       background-color: #5a9cf8;
//       padding: 0px;
//       height: 48px;
//       @include flex_mid;
//       .el-dialog__title {
//         font-size: 20px;
//         color: #ffffff;
//       }
//     }
//     /*输入框后面加<元>*/
//     .el-dialog__body {
//       padding: 30px;
//       border-bottom: 1px #dfe1e6 solid;
//       .el-form-item {
//         margin-bottom: 15px;
//       }
//     }
//     /*底部按钮居中和大小*/
//     .el-dialog__footer {
//       height: 89px;
//       padding: 0;
//       display: flex;
//       justify-content: center;
//       .dialog-footer {
//         align-self: center;
//         .el-button {
//           width: 155px;
//           height: 39px;
//         }
//       }
//     }
//   }
// }
//
</style>
<style lang="scss" scoped>
.new-ui {
  ::v-deep {
    .el-dialog {
      padding: 30px 20px 20px 20px;
      &__header {
        padding-top: 0;
        .el-dialog__title {
          font-size: 18px;
          font-weight: bold;
          line-height: 1;
        }
      }
      &__body {
        padding: 0;
        padding-bottom: 20px;
        transform: none;
      }
      &__footer {
        padding: 0;
        .xrk-dialog-footer {
          margin: 0;
          .el-button {
            padding: 0 15px;
            min-width: 77px;
            height: 28px;
            border-radius: 100px;
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>
